import { controller_game } from '@lc/controller/game';
import { GameManager } from '@lc/interface/gameManager/types';
import { createBotPlayerData } from '@lc/lib/ai_helper';
import { getRandomArrayIndex } from '@lc/lib/array';

class AI_Decision {
	async chooseCardResolution(gameManager: GameManager) {
		const { gameState } = gameManager;

		const randomTargetIndex = getRandomArrayIndex(
			gameState.decisionTargetArr
		);
		const targetId =
			gameState.decisionTargetArr[randomTargetIndex].player_id;

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			targetId,
		};

		await controller_game.makeDecision(botPlayerData, gameManager);
	}

	async chooseSummitCard(gameManager: GameManager) {
		const { gameState } = gameManager;

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			cardId: gameState.summitDraftCardIds[0],
		};

		await controller_game.makeDecisionSummitDraftCardId(
			botPlayerData,
			gameManager
		);
	}

	async chooseTurnOrder(gameManager: GameManager) {
		const { gameState } = gameManager;

		const randomTargetIndex = getRandomArrayIndex(
			gameState.decisionTargetArr
		);
		const targetId =
			gameState.currentTurnTypePlayerTableOrder[randomTargetIndex];

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			targetId,
		};

		await controller_game.makeDecisionTurnOrder(botPlayerData, gameManager);
	}

	async endTurn(gameManager: GameManager) {
		const botPlayerData = createBotPlayerData(gameManager);

		// ticker.unshift('Player ' + activePlayerId + ' ' + endTurn);
		await controller_game.endTurn(botPlayerData, gameManager);
	}
}

export const ai_decision = new AI_Decision();
